/* eslint-disable sonarjs/no-duplicate-string */
import { dataTableCopy } from "./dataTableCopy";
import { disclosuresCopy } from "./disclosuresCopy";

export const reportCases = [
  ["cash", "equity"],
  ["cash", "corp"],
  ["cash", "muni"],
  ["cash", "treasury"],
  ["cash", "tbill"],
  ["transition", "equity"],
  ["transition", "corp"],
  ["transition", "muni"],
];
const getCoverFootnotes = () => ({
  type: "div",
  children: [
    {
      type: "div",
      props: { className: "cover-page__disclosure" },
      children: [
        {
          type: "p",
          children: disclosuresCopy.cover.allData,
        },
        {
          type: "p",
          children: disclosuresCopy.cover.thisInformation,
        },
        {
          type: "p",
          children: disclosuresCopy.cover.anyUnauthorizedReview,
        },
      ],
    },
    {
      type: "div",
      props: {
        className: "cover-page__footer-text",
      },
      children: { type: "p", children: dataTableCopy.legalCopy },
    },
  ],
});

export const CASH_CORP_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "ESG Rating",
  "Key Rate Durations",
  "Sectors",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const CASH_EQUITY_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Portfolio Characteristics",
  "Attribution of Tracking Error",
  "Sectors GICS",
  "Sectors Risk Exposure",
  "Style Risk Exposure",
  "Target Portfolio",
  "Definitions",
  "Disclosures",
];

export const CASH_MUNI_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "Key Rate Durations",
  "Sectors",
  "State Exposure",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const CASH_TBILL_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Maturity",
  "Credit Quality",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const CASH_TREASURY_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Proposed Portfolio",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "Key Rate Durations",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const TRANSITION_CORP_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Transition Summary",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "ESG Rating",
  "Key Rate Durations",
  "Sectors",
  "Proposed Sells",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const TRANSITION_EQUITY_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Transition Summary",
  "Portfolio Characteristics",
  "Attribution of Tracking Error",
  "Sectors GICS",
  "Sectors Risk Exposure",
  "Style Risk Exposure",
  "Proposed Sells",
  "Definitions",
  "Disclosures",
];

export const TRANSITION_MUNI_CUSTOMIZATION_LABELS = [
  "Firm Overview",
  "1-Sheeter Summary",
  "Transition Summary",
  "Portfolio Characteristics",
  "Coupon Cash Flow",
  "Maturity",
  "Credit Quality",
  "Key Rate Durations",
  "Sectors",
  "State Exposure",
  "Proposed Sells",
  "Interest Rate Analysis",
  "Scenario Analysis",
  "Definitions",
  "Disclosures",
];

export const AVAILABLE_SECTIONS_LIST_PER_REPORT = {
  cash: {
    corp: CASH_CORP_CUSTOMIZATION_LABELS,
    equity: CASH_EQUITY_CUSTOMIZATION_LABELS,
    muni: CASH_MUNI_CUSTOMIZATION_LABELS,
    treasury: CASH_TREASURY_CUSTOMIZATION_LABELS,
    tbill: CASH_TBILL_CUSTOMIZATION_LABELS,
  },
  transition: {
    corp: TRANSITION_CORP_CUSTOMIZATION_LABELS,
    equity: TRANSITION_EQUITY_CUSTOMIZATION_LABELS,
    muni: TRANSITION_MUNI_CUSTOMIZATION_LABELS,
    treasury: [],
    tbill: [],
  },
};

export const SECTIONS_METADATA = {
  AttributionOfTrackingError: {
    // Identifiers
    sectionMetadataKey: "AttributionOfTrackingError",
    sectionKey: "Attribution of Tracking Error",
    sectionKeyKebab: "attribution-of-tracking-error",
    filename: "attributionOfTrackingError",

    // Data
    title: "Attribution of Tracking Error",
    subtitle: "",

    // Formatting and styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Attribution of Tracking Error",
      sectionMetadataKey: "AttributionOfTrackingError",
      sectionKeyKebab: "attribution-of-tracking-error",
    },

    chart1: {
      id: "report-attribution-of-tracking-error",
      containerId: "report-attribution-of-tracking-error",
      type: "bar",
      height: "230px",
      legendId: "legend-report-attribution-of-tracking-error",
      legendTitle: "Sources of Tracking Error",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Attribution of Tracking Error Data Table",
      tableRowHeaderKey: "Sources of Tracking Error",
    },
  },
  CashFlowProfile: {
    // Identifiers
    sectionMetadataKey: "CashFlowProfile",
    sectionKey: "Cash Flow Profile",
    sectionKeyKebab: "cash-flow-profile",
    filename: "couponCashFlow",

    // Data
    title: "Proposed Coupon Cash Flow Profile",
    subtitle: "",
    titleAlternative: "Proposed Coupon Cash Flow Profile",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Coupon Cash Flow",
      sectionMetadataKey: "CashFlowProfile",
      sectionKeyKebab: "cash-flow-profile",
    },

    chart1: {
      id: "report-coupon-cash-flow",
      containerId: "report-coupon-cash-flow",
      legendId: "legend-report-coupon-cash-flow",
      title: "Coupon Cash Flow",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Cash Flow Profile Data Table",
      tableRowHeaderKey: "Month",
    },
  },
  Cover: {
    // Identifiers
    sectionMetadataKey: "Cover",
    sectionKey: "Cover",
    sectionKeyKebab: "cover",
    filename: "cover",

    // Data
    title: "Remi Cash Proposal",
    subtitle: "",
    titleAlternative: "Remi Transition Proposal",

    footnotes: getCoverFootnotes(),

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Cover",
      sectionMetadataKey: "Cover",
      sectionKeyKebab: "cover",
    },
  },
  CreditQuality: {
    // Identifiers
    sectionMetadataKey: "CreditQuality",
    sectionKey: "Credit Quality",
    sectionKeyKebab: "credit-quality",
    filename: "creditQuality",

    // Data
    title: "Proposed Credit Quality",
    titleAlternative: "",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Credit Quality",
      sectionMetadataKey: "CreditQuality",
      sectionKeyKebab: "credit-quality",
    },

    chart1: {
      id: "report-credit-quality",
      containerId: "report-credit-quality",
      legendId: "legend-report-credit-quality",
      type: "bar",
      height: "177px",
      legendTitle: "Credit Quality (by bucket)",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Credit Quality Data Table",
      tableRowHeaderKey: "Credit Quality (by bucket)",
    },
  },
  Definitions: {
    // Identifiers
    sectionMetadataKey: "Definitions",
    sectionKey: "Definitions",
    sectionKeyKebab: "definitions",
    filename: "definitions",

    // Data
    title: "Definitions",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Definitions",
      sectionMetadataKey: "Definitions",
      sectionKeyKebab: "definitions",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },
  },
  Disclosures: {
    // Identifiers
    sectionMetadataKey: "Disclosures",
    sectionKey: "Disclosures",
    sectionKeyKebab: "disclosures",
    filename: "disclosures",

    // Data
    title: "Disclosures",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Disclosures",
      sectionMetadataKey: "Disclosures",
      sectionKeyKebab: "disclosures",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },
  },
  ESGRating: {
    // Identifiers
    sectionMetadataKey: "ESGRating",
    sectionKey: "ESG Rating",
    sectionKeyKebab: "esg-rating",
    filename: "esgRating",

    // Data
    title: "ESG Rating",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "ESG Rating",
      sectionMetadataKey: "ESGRating",
      sectionKeyKebab: "esg-rating",
    },

    chart1: {
      id: "report-esg-ratings",
      containerId: "report-esg-ratings",
      legendId: "legend-report-esg-ratings",
      type: "bar",
      height: "330px",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "ESG Rating Data Table",
      tableRowHeaderKey: "ESG Rating (By Bucket)",
    },
  },
  FirmOverview: {
    // Identifiers
    sectionMetadataKey: "FirmOverview",
    sectionKey: "Firm Overview",
    sectionKeyKebab: "firm-overview",
    filename: "firmOverview",

    // Data
    title: "Firm Overview",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Firm Overview",
      sectionMetadataKey: "FirmOverview",
      sectionKeyKebab: "firm-overview",
    },
  },
  InterestRateAnalysis: {
    // Identifiers
    sectionMetadataKey: "InterestRateAnalysis",
    sectionKey: "Interest Rate Analysis",
    sectionKeyKebab: "interest-rate-analysis",
    filename: "interestRateSensitivityAnalysis",

    // Data
    title: "Interest Rate Sensitivity Analysis",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Interest Rate Analysis",
      sectionMetadataKey: "InterestRateAnalysis",
      sectionKeyKebab: "interest-rate-analysis",
    },

    chart1: {
      id: "report-interest-rate-analysis",
      containerId: "report-interest-rate-analysis",
      legendId: "legend-report-interest-rate-analysis",
      type: "bar",
      height: "",
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Interest Rate Analysis Data Table",
      tableRowHeaderKey: "Yield Change (bps)",
    },
  },
  KeyRate: {
    // Identifiers
    sectionMetadataKey: "KeyRate",
    sectionKey: "Key Rate",
    sectionKeyKebab: "key-rate",
    filename: "keyRateDurations",

    // Data
    title: "Proposed Key Rate Durations",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Key Rate Durations",
      sectionMetadataKey: "KeyRate",
      sectionKeyKebab: "key-rate",
    },

    chart1: {
      id: "report-key-rate-durations",
      containerId: "report-key-rate-durations",
      legendId: "legend-report-key-rate-durations",
      type: "bar",
      height: "230px",
      legendTitle: "Proposed Key Rate Durations",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Key Rate Data Table",
      tableRowHeaderKey: "Proposed Key Rate Durations",
    },
  },
  Maturity: {
    // Identifiers
    sectionMetadataKey: "Maturity",
    sectionKey: "Maturity",
    sectionKeyKebab: "maturity",
    filename: "maturity",

    // Data
    title: "Proposed Maturity",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Maturity",
      sectionMetadataKey: "Maturity",
      sectionKeyKebab: "maturity",
    },

    chart1: {
      id: "report-maturity",
      containerId: "report-maturity",
      legendId: "legend-report-maturity",
      type: "bar",
      height: "250px",
      legendTitle: "Maturity (by bucket)",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Maturity Data Table",
      tableRowHeaderKey: "Maturity (by bucket)",
    },
  },
  OneSheeterSummary: {
    // Identifiers
    sectionMetadataKey: "OneSheeterSummary",
    sectionKey: "1-Sheeter Summary",
    sectionKeyKebab: "one-sheeter",
    filename: "oneSheeterSummary",

    // Data
    title: "Proposal",
    subtitle: "",

    // Formatting and styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "1-Sheeter Summary",
      sectionMetadataKey: "OneSheeterSummary",
      sectionKeyKebab: "one-sheeter",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },

    chart1: {
      id: "report-one-sheeter-coupon-cash-flow",
      containerId: "report-one-sheeter-coupon-cash-flow",
      legendId: "legend-report-one-sheeter-coupon-cash-flow",
      title: "Coupon Cash Flow",
      type: "line",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
    chart2: {
      id: "report-one-sheeter-sectors-gics",
      containerId: "report-one-sheeter-sectors-gics",
      legendId: "legend-report-one-sheeter-sectors-gics",
      title: "Sectors (GICS®)[1]",
      type: "bar",
      height: "280px",
      isReversed: true,
    },
    chart3: {
      id: "report-one-sheeter-attribution-tracking-error",
      containerId: "report-one-sheeter-attribution-tracking-error",
      legendId: "legend-report-one-sheeter-attribution-tracking-error",
      title: "Attribution of Tracking Error",
      type: "bar",
      height: "180px",
      legendTitle: "Sources of Tracking Error",
      isReversed: true,
    },
  },
  PortfolioCharacteristics: {
    // Identifiers
    sectionMetadataKey: "PortfolioCharacteristics",
    sectionKey: "Portfolio Characteristics",
    sectionKeyKebab: "portfolio-characteristics",
    filename: "portfolioCharacteristics",

    // Data
    title: "Proposed Portfolio Characteristics",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Portfolio Characteristics",
      sectionMetadataKey: "PortfolioCharacteristics",
      sectionKeyKebab: "portfolio-characteristics",
    },
    table1: {
      tableCaption: "Portfolio Characteristics Data Table",
      tableRowHeaderKey: "Portfolio Characteristics",
    },
  },
  Portfolio: {
    // Identifiers
    sectionMetadataKey: "Portfolio",
    sectionKey: "Portfolio",
    sectionKeyKebab: "portfolio",
    filename: "proposedPortfolio",

    // Data
    title: "Target Portfolio",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "max",
    customizations: {
      label: "Proposed Portfolio",
      sectionMetadataKey: "Portfolio",
      sectionKeyKebab: "portfolio",
    },
    table1: {
      tableCaption: "Portfolio Data Table",
      tableRowHeaderKey: "Security Code",
    },
  },
  ProposedSells: {
    // Identifiers
    sectionMetadataKey: "ProposedSells",
    sectionKey: "Proposed Sells",
    sectionKeyAlternative: "Proposed Sell",
    sectionKeyKebab: "proposed-sells",
    filename: "proposedSells",

    // Data
    title: "Proposed Sells",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "max",
    customizations: {
      label: "Proposed Sells",
      sectionMetadataKey: "ProposedSells",
      sectionKeyKebab: "proposed-sells",
    },
    table1: {
      tableCaption: "Proposed Sells Data Table",
      tableRowHeaderKey: "CUSIP",
    },
  },
  ScenarioAnalysis: {
    // Identifiers
    sectionMetadataKey: "ScenarioAnalysis",
    sectionKey: "Scenario Analysis",
    sectionKeyKebab: "scenario-analysis",
    filename: "scenarioAnalysis",

    // Data
    title: "Scenario Analysis",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Scenario Analysis",
      sectionMetadataKey: "ScenarioAnalysis",
      sectionKeyKebab: "scenario-analysis",
    },

    chart1: {
      id: "report-scenario-analysis",
      containerId: "report-scenario-analysis",
      legendId: "legend-report-scenario-analysis",
      type: "bar",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Scenario Analysis Data Table",
      tableRowHeaderKey: "Scenario Name",
    },
  },
  Sectors: {
    // Identifiers
    sectionMetadataKey: "Sectors",
    sectionKey: "Sector",
    sectionKeyKebab: "sectors",
    filename: "sectors",

    // Data
    title: "Proposed Sectors",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Sectors",
      sectionMetadataKey: "Sectors",
      sectionKeyKebab: "sectors",
    },

    chart1: {
      id: "report-sector",
      containerId: "report-sector",
      legendId: "legend-report-sector",
      type: "bar",
      height: "330px",
      isReversed: true,
      isFullWidth: true,
    },
    table1: {
      tableCaption: "Sector Data Table",
      tableRowHeaderKey: "Sectors",
    },
  },
  SectorsGICS: {
    // Identifiers
    sectionMetadataKey: "SectorsGICS",
    sectionKey: "Sectors (GICS)",
    sectionKeyKebab: "sectors-gics",
    filename: "sectorsGICS",

    // Data
    title: "Sectors (GICS®)",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: true,
    variation: "stylized",
    customizations: {
      label: "Sectors GICS",
      sectionMetadataKey: "SectorsGICS",
      sectionKeyKebab: "sectors-gics",
    },

    chart1: {
      id: "report-sectors-gics",
      containerId: "report-sectors-gics",
      legendId: "legend-report-sectors-gics",
      type: "bar",
      height: "250px",
      isFullWidth: true,
      isReversed: true,
    },
    table1: {
      tableCaption: "Sectors (GICS) Data Table",
      tableRowHeaderKey: "Sectors",
    },
  },
  SectorsRiskExposure: {
    // Identifiers
    sectionMetadataKey: "SectorsRiskExposure",
    sectionKey: "Sectors (Risk Exposure)",
    sectionKeyKebab: "sectors-risk-exposure",
    filename: "sectorsRiskExposure",

    // Data
    title: "Sectors (Risk Exposure)",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: true,
    variation: "stylized",
    customizations: {
      label: "Sectors Risk Exposure",
      sectionMetadataKey: "SectorsRiskExposure",
      sectionKeyKebab: "sectors-risk-exposure",
    },

    chart1: {
      id: "report-sectors-risk-exposure",
      containerId: "report-sectors-risk-exposure",
      legendId: "legend-report-sectors-risk-exposure",
      type: "bar",
      height: "250px",
      isFullWidth: true,
      isReversed: true,
    },
    table1: {
      tableCaption: "Sectors (Risk Exposure) Data Table",
      tableRowHeaderKey: "Sectors",
    },
  },
  State: {
    // Identifiers
    sectionMetadataKey: "State",
    sectionKey: "State",
    sectionKeyKebab: "state",
    filename: "stateExposure",

    // Data
    title: "Proposed State Exposure",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "State Exposure",
      sectionMetadataKey: "State",
      sectionKeyKebab: "state",
    },
    table1: {
      tableCaption: "State Data Table",
      tableRowHeaderKey: "State Exposure",
    },
  },
  StaticPageReport: {
    // Identifiers
    sectionMetadataKey: "StaticPageReport",
    sectionKey: "StaticPageReport",
    sectionKeyKebab: "static-page-report",
    filename: "staticPageReport",
    // Data
    title: "Static Page Report",
    subtitle: "",
    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "StaticPageReport",
      sectionMetadataKey: "StaticPageReport",
      sectionKeyKebab: "static-page-report",
      options: {
        checked: true,
        readOnly: true,
        locked: true,
      },
    },
  },
  StyleRiskExposure: {
    // Identifiers
    sectionMetadataKey: "StyleRiskExposure",
    sectionKey: "Style (Risk Exposure)",
    sectionKeyKebab: "style-risk-exposure",
    filename: "styleRiskExposure",

    // Data
    title: "Style Risk Exposure",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: true,
    variation: "stylized",
    customizations: {
      label: "Style Risk Exposure",
      sectionMetadataKey: "StyleRiskExposure",
      sectionKeyKebab: "style-risk-exposure",
    },
    table1: {
      tableCaption: "Style (Risk Exposure) Data Table",
      tableRowHeaderKey: "Style Risks",
    },
  },
  TargetPortfolio: {
    // Identifiers
    sectionMetadataKey: "TargetPortfolio",
    sectionKey: "Target Portfolio*",
    sectionKeyKebab: "target-portfolio",
    filename: "targetPortfolio",

    // Data
    title: "Target Portfolio",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "column",
    hasProfitLabel: false,
    variation: "max",
    customizations: {
      label: "Target Portfolio",
      sectionMetadataKey: "TargetPortfolio",
      sectionKeyKebab: "target-portfolio",
    },
    table1: {
      tableCaption: "Target Portfolio Data Table",
      tableRowHeaderKey: "Ticker",
    },
  },
  TransitionSummary: {
    // Identifiers
    sectionMetadataKey: "TransitionSummary",
    sectionKey: "Transition Summary",
    sectionKeyKebab: "transition-summary",
    filename: "transitionSummary",

    // Data
    title: "Transition Summary",
    subtitle: "",

    // Formatting and Styling
    formatCellDataBy: "row",
    hasProfitLabel: false,
    variation: "stylized",
    customizations: {
      label: "Transition Summary",
      sectionMetadataKey: "TransitionSummary",
      sectionKeyKebab: "transition-summary",
    },
    table1: {
      tableCaption: "Transition Summary Data Table",
      tableRowHeaderKey: "",
    },

    chart1: {
      id: "report-transition-summary",
      containerId: "report-transition-summary",
      legendId: "legend-report-transition-summary",
      type: "bar",
      height: "230px",
      isReversed: false,
      isFullWidth: true,
    },
  },
};
